var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, $state, $stateParams, $window) {
    var ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
        $scope.confirmedClaimId = $stateParams.claimNumber;
    };

    ctrl.printConfirmation = function () {
        $window.print();
    };

    ctrl.gotBackToHomeState = function () {
        var _$stateParams$returnS = _slicedToArray($stateParams.returnStateInfo, 2),
            stateName = _$stateParams$returnS[0],
            stateParms = _$stateParams$returnS[1];

        $state.go(stateName, stateParms);
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$state', '$stateParams', '$window'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/common/controllers/ConfirmationCtrl.js
// module id = 1515
// module chunks = 0